module.exports = __webpack_public_path__ + "assets/img/ic-message-gray.1f2c1342.svg";